import styled from 'styled-components'
import { sc } from 'utils'

type Props = {
  secondary?: boolean
  tertiary?: boolean
  warning?: boolean
  small?: boolean
  color?: string
}

const buttonBg = ({ secondary, tertiary, warning }: Props) => {
  if (secondary) return 'var(--white)'
  if (tertiary) return 'transparent'
  if (warning) return 'var(--orange)'
  return 'var(--green)'
}

const buttonTextColor = ({ color, secondary, tertiary, warning }: Props) => {
  if (color) return color
  if ((secondary || tertiary) && warning) return 'var(--orange)'
  if (secondary || tertiary) return 'var(--green)'
  return 'var(--white)'
}

const buttonHoverBg = ({ secondary, warning }: Props) => {
  if (warning && secondary) return 'var(--light-orange)'
  if (warning) return 'var(--dark-orange)'
  if (secondary) return 'var(--very-light-green)'
  return 'var(--dark-green)'
}

export default styled.button<Props>`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: ${sc('small', '8px 16px', '16px')};

  background-color: ${buttonBg};

  border-radius: 4px;
  border: 1px solid transparent;

  color: ${buttonTextColor};
  font: var(--600-12);
  text-align: center;
  text-transform: uppercase;

  cursor: pointer;
  appearance: none;
  user-select: none;
  transition: background-color 0.2s;

  svg {
    fill: ${buttonTextColor};
  }

  :hover:enabled:not(:focus-visible) {
    background-color: ${buttonHoverBg};
  }

  :focus-visible {
    outline: 2px solid var(--green_0-5);
  }

  :enabled {
    border-color: ${({ secondary, tertiary, warning }) =>
      secondary || tertiary || warning ? 'currentColor' : 'transparent'};
  }

  :disabled {
    /* !important is making sure buttons with inline styles are properly marked as disabled */
    background: var(--light-gray) !important;
    color: white !important;
    cursor: not-allowed;
  }
`
